import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

import { getAPI } from '../util/APIUtils';

import { viewerActions } from './viewerAction';
import { Caption, Metadata, Catalog, History, Revisiondata } from '../states/viewerState';

export interface Profile {
    id: string;
    name: string;
    email: string;
    accountid: string;
    govName: string;
    govNameSuffix: string;
    userGroupId: string;
    startDate: string;
    role: string;
    idid: string;
}

const actionCreator = actionCreatorFactory();

const initCaption = (captionList: Caption[]): { captionList: Caption[], countHasChild: number } => {
    let hasChildIndex = 0;
    const f = (l: Caption[], level: number = 0, saiLevel: number = 0) => {
        return l.map((item) => {
            const c = item.childCaptionList ? hasChildIndex++ : -1;
            const sl = item.type === '15' ? saiLevel + 1 : 0;
            let newitem;
            if (item.childCaptionList) {
                newitem = Object.assign({}, item, {
                    level: level,
                    hasChildIndex: c,
                    childCaptionList: f(item.childCaptionList, level + 1, sl),
                });
            } else {
                newitem = Object.assign({}, item, {
                    level: level,
                    hasChildIndex: c,
                });
            }
            if (sl > 0) newitem.saiLevel = sl;
            return newitem;
        });
    };
    return { captionList: f(captionList), countHasChild: hasChildIndex };
};

const initMetadata = (metadata: Metadata): Metadata => {
    let hasCatalogChildIndex = 0;
    const initCatalog = (item: Catalog, level: number = 0) => {
        const c = item.child ? hasCatalogChildIndex++ : -1;
        let newitem;
        if (item.child) {
            newitem = Object.assign({}, item, {
                level: level,
                hasChildIndex: c,
                child: initCatalog(item.child, level + 1,),
            });
        } else {
            newitem = Object.assign({}, item, {
                level: level,
                hasChildIndex: c,
            });
        }
        return newitem;
    };

    let hasHistoryChildIndex = 0;
    const initHistory = (history: History[], level: number = 0) => {
        const initRevisiondata = (revisiondata: Revisiondata[], level: number = 0) => {
            return revisiondata.map((item) => {
                return Object.assign({}, item, {
                    level: 1,
                    hasChildIndex: -1,
                });
            });
        };
        return history.map((item) => {
            return Object.assign({}, item, {
                level: level,
                hasChildIndex: hasHistoryChildIndex++,
                revisiondata: initRevisiondata(item.revisiondata),
            });
        });
    };

    const newMetadata: Metadata = {
        title: metadata.title,
        actNum: metadata.actNum,
        field: metadata.field,
        catalog: initCatalog(metadata.catalog),
        history: initHistory(metadata.history),
        countHasCatalogChild: hasCatalogChildIndex,
        countHasHistoryChild: hasHistoryChildIndex
    }
    return newMetadata;
};

export const appActions = {
    setLoading: actionCreator<boolean>('ACTIONS_SET_LOADING'),
    initViewer: actionCreator<Profile>('ACTION_INIT_PROFILE'),
    initRevisionViewerAsync: (actId: string, revision: string, miekesi: boolean, highlight: string, nodeId: string, mode: 'history' | 'current') => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                //const response = await Auth.currentUserInfo();
                const userS = await fetchAuthSession();
                const user = await getCurrentUser();

                // ユーザ情報取得API呼び出し
                const url1 = `/user/${user.username}`;
                const json1 = await getAPI(url1);

                const result: Profile = {
                    id: user.username,
                    name: json1.name,
                    email: json1.eMail,
                    accountid: json1.accountId,
                    govName: json1.govName,
                    govNameSuffix: json1.govNameSuffix,
                    userGroupId: json1.userGroupId,
                    startDate: json1.startDate,
                    role: json1.role,
                    idid: userS.identityId || user.username,
                };

                dispatch(appActions.initViewer(result));

                const url = `/acts/${actId}/${revision}/viewing`;
                const param = `?idid=${result.idid}&accountid=${result.accountid}&miekesi=${miekesi}&highlight=${highlight}&nodeId=${nodeId}&mode=${mode}`;
                const json = await getAPI(url + param);
                const r = initCaption(json.caption);
                const newMeatadata = initMetadata(json.metadata);

                dispatch(viewerActions.initViewer({
                    type: 'revision',
                    actId: actId,
                    revision: json.revision,
                    editingId: '',
                    stepId: '',
                    miekesi: miekesi,
                    highlight: highlight,
                    nodeId: nodeId,
                    contents: json.contents,
                    metadata: newMeatadata,
                    caption: r.captionList,
                    countHasChild: r.countHasChild,
                    actState: json.actState,
                    mode: mode,
                    title: json.title,
                    maxStepId: 1,
                    posNextPrev: -1,
                }));

            } catch (err) {
                console.log(err);
            }
            dispatch(appActions.setLoading(false));
            // 画面描画後に対象ノードIDにジャンプするようViewer.tsxのuseEffectでジャンプ
        };
    },
    initEditingViewerAsync: (actId: string, editingId: string, stepId: string, miekesi: boolean) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                // const response = await Auth.currentUserInfo();
                const userS = await fetchAuthSession();
                const user = await getCurrentUser();

                // ユーザ情報取得API呼び出し
                const url1 = `/user/${user.username}`;
                const json1 = await getAPI(url1);

                const result: Profile = {
                    id: user.username,
                    name: json1.name,
                    email: json1.eMail,
                    accountid: json1.accountId,
                    govName: json1.govName,
                    govNameSuffix: json1.govNameSuffix,
                    userGroupId: json1.userGroupId,
                    startDate: json1.startDate,
                    role: json1.role,
                    idid: userS.identityId || user.username,
                };

                dispatch(appActions.initViewer(result));

                const url = `/acts/${actId}/editings/${editingId}/steps/${stepId}/viewing`;
                const param = `?idid=${result.idid}&accountid=${result.accountid}&miekesi=${miekesi}`;
                const json = await getAPI(url + param);
                const r = initCaption(json.caption);

                dispatch(viewerActions.initViewer({
                    type: 'editing',
                    actId: actId,
                    revision: '',
                    editingId: editingId,
                    stepId: stepId,
                    miekesi: miekesi,
                    highlight: '',
                    nodeId: '',
                    contents: json.contents,
                    metadata: json.metadata,
                    caption: r.captionList,
                    countHasChild: r.countHasChild,
                    actState: json.actState,
                    mode: 'current',
                    title: json.title,
                    maxStepId: json.maxStepId,
                    posNextPrev: -1,
                }));

            } catch (err) {
                console.log(err);
            }
            dispatch(appActions.setLoading(false));
        };
    },
    initExaminationViewerAsync: (actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                // const response = await Auth.currentUserInfo();
                const userS = await fetchAuthSession();
                const user = await getCurrentUser();

                // ユーザ情報取得API呼び出し
                const url1 = `/user/${user.username}`;
                const json1 = await getAPI(url1);

                const result: Profile = {
                    id: user.username,
                    name: json1.name,
                    email: json1.eMail,
                    accountid: json1.accountId,
                    govName: json1.govName,
                    govNameSuffix: json1.govNameSuffix,
                    userGroupId: json1.userGroupId,
                    startDate: json1.startDate,
                    role: json1.role,
                    idid: userS.identityId || user.username,
                };

                dispatch(appActions.initViewer(result));

                const url = `/acts/${actId}/editings/${editingId}/steps/${stepId}/examination`;
                const param = `?idid=${result.idid}&accountid=${result.accountid}&examinationtype=${examinationtype}&miekesi=${miekesi}`;
                const json = await getAPI(url + param);
                const r = initCaption(json.caption);

                dispatch(viewerActions.initViewer({
                    type: 'examination',
                    actId: actId,
                    revision: '',
                    editingId: editingId,
                    stepId: stepId,
                    miekesi: miekesi,
                    highlight: '',
                    nodeId: '',
                    contents: json.contents,
                    metadata: json.metadata,
                    caption: r.captionList,
                    countHasChild: r.countHasChild,
                    actState: json.actState,
                    mode: 'current',
                    title: json.title,
                    maxStepId: json.maxStepId,
                    posNextPrev: -1,
                }));

            } catch (err) {
                console.log(err);
            }
            dispatch(appActions.setLoading(false));
        };
    },
    examinationViewerAsync: (accountid: string, idid: string, actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => {
        return async (dispatch: Dispatch<Action>) => {
            try {
                const url = `/acts/${actId}/editings/${editingId}/steps/${stepId}/examination`;
                const param = `?idid=${idid}&accountid=${accountid}&examinationtype=${examinationtype}&miekesi=${miekesi}`;
                const json = await getAPI(url + param);
                const r = initCaption(json.caption);

                dispatch(viewerActions.initViewer({
                    type: 'examination',
                    actId: actId,
                    revision: '',
                    editingId: editingId,
                    stepId: stepId,
                    miekesi: miekesi,
                    highlight: '',
                    nodeId: '',
                    contents: json.contents,
                    metadata: json.metadata,
                    caption: r.captionList,
                    countHasChild: r.countHasChild,
                    actState: json.actState,
                    mode: 'current',
                    title: json.title,
                    maxStepId: json.maxStepId,
                    posNextPrev: -1,
                }));

            } catch (err) {
                console.log(err);
            }
            dispatch(appActions.setLoading(false));
        };
    },
};
